import React from 'react';
import EllipsisTooltip from '@/components/Layout/Customer/components/ellipsisTooltip/ellipsisTooltip';
import { getIn18Text } from 'api';
const getColumns = (isInMailAPage) => {
    const renderEllipsisTooltip = (text) => React.createElement(EllipsisTooltip, { contentClassName: "double-row" }, text || '-');
    if (!isInMailAPage) {
        return [
            {
                title: getIn18Text('SHANGPINZHONGWENMINGCHENG'),
                dataIndex: 'product_name_cn',
                width: 120,
                ellipsis: {
                    showTitle: false,
                },
                render: val => {
                    return React.createElement("div", { style: { width: 120 } }, renderEllipsisTooltip(val));
                },
            },
            {
                title: getIn18Text('SHANGPINYINGWENMINGCHENG'),
                width: 120,
                ellipsis: {
                    showTitle: false,
                },
                dataIndex: 'product_name_en',
                render: val => {
                    return React.createElement("div", { style: { width: 120 } }, renderEllipsisTooltip(val));
                },
            },
            {
                title: getIn18Text('SHANGPINBIANHAO'),
                width: 140,
                ellipsis: {
                    showTitle: false,
                },
                dataIndex: 'product_number',
                render: renderEllipsisTooltip,
            },
            {
                title: getIn18Text('YANSE'),
                width: 80,
                ellipsis: {
                    showTitle: false,
                },
                dataIndex: 'color',
                render: renderEllipsisTooltip,
            },
            {
                title: getIn18Text('XIAOSHOUBIZHONG'),
                width: 100,
                ellipsis: {
                    showTitle: false,
                },
                dataIndex: 'price_currency',
                render: renderEllipsisTooltip,
            },
            {
                title: getIn18Text('XIAOSHOUDANJIA'),
                width: 80,
                ellipsis: {
                    showTitle: false,
                },
                dataIndex: 'price',
                render: (text, record) => renderEllipsisTooltip(record.priceRange || text),
            },
            {
                title: getIn18Text('SHANGPINXINGHAO'),
                width: 110,
                ellipsis: {
                    showTitle: false,
                },
                dataIndex: 'length',
                render: (text, record) => {
                    let str = '';
                    if (record.length) {
                        str += `L(${record.length})`;
                    }
                    if (record.width) {
                        if (str) {
                            str += '*';
                        }
                        str += `W(${record.width})`;
                    }
                    if (record.height) {
                        if (str) {
                            str += '*';
                        }
                        str += `H(${record.height})`;
                    }
                    return renderEllipsisTooltip(str);
                },
            },
        ];
    }
    return [
        {
            title: '商品规格',
            dataIndex: 'template',
            width: 160,
            fixed: 'left',
            render: (text, record) => {
                const _text = record === null || record === void 0 ? void 0 : record.specificationInfo;
                return React.createElement("div", { className: "stockCol" }, record.isSPU ? `${record.stockLength > 0 ? `${record.stockLength}个规格` : '无规格'}` : _text);
            },
        },
        {
            title: getIn18Text('SHANGPINZHONGWENMINGCHENG'),
            dataIndex: 'product_name_cn',
            width: 120,
            ellipsis: {
                showTitle: false,
            },
            render: val => {
                return React.createElement("div", { style: { width: 120 } }, renderEllipsisTooltip(val));
            },
        },
        {
            title: getIn18Text('SHANGPINYINGWENMINGCHENG'),
            width: 120,
            ellipsis: {
                showTitle: false,
            },
            dataIndex: 'product_name_en',
            render: val => {
                return React.createElement("div", { style: { width: 120 } }, renderEllipsisTooltip(val));
            },
        },
        {
            title: getIn18Text('SHANGPINBIANHAO'),
            width: 140,
            ellipsis: {
                showTitle: false,
            },
            dataIndex: 'product_number',
            render: renderEllipsisTooltip,
        },
        {
            title: getIn18Text('XIAOSHOUBIZHONG'),
            width: 100,
            ellipsis: {
                showTitle: false,
            },
            dataIndex: 'price_currency',
            render: renderEllipsisTooltip,
        },
        {
            title: getIn18Text('XIAOSHOUDANJIA'),
            width: 80,
            ellipsis: {
                showTitle: false,
            },
            dataIndex: 'price',
            render: (text, record) => renderEllipsisTooltip(record.priceRange || text),
        },
        {
            title: getIn18Text('SHANGPINXINGHAO'),
            width: 110,
            ellipsis: {
                showTitle: false,
            },
            dataIndex: 'length',
            render: (text, record) => {
                let str = '';
                if (record.length) {
                    str += `L(${record.length})`;
                }
                if (record.width) {
                    if (str) {
                        str += '*';
                    }
                    str += `W(${record.width})`;
                }
                if (record.height) {
                    if (str) {
                        str += '*';
                    }
                    str += `H(${record.height})`;
                }
                return renderEllipsisTooltip(str);
            },
        },
    ];
};
export { getColumns };
